const TokenKey = 'token'
const UserKey = 'user'
const AppIdKey = 'appId'

export default {
  getToken () {
    return window.sessionStorage.getItem(TokenKey)
  },
  setToken (token) {
    window.sessionStorage.setItem(TokenKey, token)
  },
  removeToken () {
    window.sessionStorage.removeItem(TokenKey)
  },
  getUser () {
    const user = window.sessionStorage.getItem(UserKey)
    if (!user) {
      return null
    }
    return JSON.parse(user)
  },
  setUser (user) {
    window.sessionStorage.setItem(UserKey, JSON.stringify(user))
  },
  removeUser () {
    window.sessionStorage.removeItem(UserKey)
  },
  getAppId () {
    return window.sessionStorage.getItem(AppIdKey)
  },
  setAppId (appId) {
    window.sessionStorage.setItem(AppIdKey, appId)
  },
  removeAppId () {
    window.sessionStorage.removeItem(AppIdKey)
  }
}



// WEBPACK FOOTER //
// ./src/store/store.js